import { z } from 'zod'

import { fromProblemV2, ProblemV2WireSchema } from '~/@entities/Problem'
import type {
  CommonResponseListConceptChipResponse,
  ConceptChipResponse,
  LevelOfConceptChipLearningDto,
} from '~/api-spec/__generated__/main'
import { parseApiResponse } from '~/schema/apiBoundary'

import { type ConceptChip, type ConceptChipCountByType, ConceptChipSchema } from './schemas'

// 유형칩 응답의 대표 문제는 V2 문제 본체로 온다. 검증은 ConceptChipWireSchema 로, 도메인 모양 풀기는 toConceptChip 으로
// 나눠 둔다(Problem adapter 의 fromProblemV2 와 같은 이유). 유형칩을 품는 다른 응답(챌린지 설정)도 둘을 함께 쓴다.
export const ConceptChipWireSchema = ConceptChipSchema.extend({
  repProblem: ProblemV2WireSchema.nullable(),
})

export const toConceptChip = ({
  repProblem,
  ...conceptChip
}: z.output<typeof ConceptChipWireSchema>): ConceptChip => ({
  ...conceptChip,
  repProblem: repProblem ? fromProblemV2(repProblem) : null,
})

export const adaptConceptChip = (raw: ConceptChipResponse): ConceptChip =>
  toConceptChip(parseApiResponse(ConceptChipWireSchema, raw, 'ConceptChip'))

export const adaptConceptChips = (
  raw: CommonResponseListConceptChipResponse['data'],
): ConceptChip[] =>
  (parseApiResponse(z.array(ConceptChipWireSchema), raw, 'ConceptChip') ?? []).map(toConceptChip)

// 학생 홈 응답들이 이 조각을 품어 스키마와 풀기 함수를 export 한다
export const ConceptChipCountByTypeWireSchema = z.object({
  conceptChipA: z.number(),
  conceptChipB: z.number(),
  conceptChipC: z.number(),
})

export type ConceptChipCountByTypeWire = LevelOfConceptChipLearningDto

// lenient 가 검증에 실패한 raw 를 넘겨도 죽지 않게 빠진 묶음은 0 으로 읽는다
export const toConceptChipCountByType = (
  wire: z.output<typeof ConceptChipCountByTypeWireSchema> | undefined,
): ConceptChipCountByType => ({
  개념: wire?.conceptChipA ?? 0,
  기본: wire?.conceptChipB ?? 0,
  심화: wire?.conceptChipC ?? 0,
})

export const adaptConceptChipCountByType = (
  raw: ConceptChipCountByTypeWire,
): ConceptChipCountByType =>
  toConceptChipCountByType(parseApiResponse(ConceptChipCountByTypeWireSchema, raw, 'ConceptChip'))
